import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

import { ErrorMessage } from '../ErrorMessage'
import { RequiredSpan } from '../RequiredSpan'

const style = (value, errors, disabled, placeholder) => {
  if (errors && errors.length) {
    return { color: '#FF5741' }
  }
  if ((!placeholder && (!value || value === 'null')) || disabled) {
    return { color: '#979797' }
  }
  return { color: 'black' }
}

export class Select extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.renderRequired = this.renderRequired.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const { data, value: thisProps } = this.props
    if (!_.isEqual(nextProps.data, data)) {
      const { value } = nextProps
      const newData = nextProps.data || []
      const { onChange } = nextProps

      if (thisProps !== 'null' && !newData.find(i => i.value === value)) {
        if (onChange) {
          onChange({
            target: {
              value: 'null'
            }
          })
        }
      }
    }
  }

  handleChange (event) {
    const { onChange } = this.props
    if (onChange) {
      onChange(event)
    }
  }

  renderRequired () {
    const { required } = this.props
    if (!required) {
      return <div />
    }
    return <RequiredSpan className='required-select' />
  }

  render () {
    const {
      label,
      placeholder,
      data,
      noSort,
      noFloatingLabel,
      value,
      errors,
      style: styles,
      onBlur,
      disabled
    } = this.props

    const options = []
    let sortedData
    if (noSort) {
      sortedData = data
    } else {
      sortedData = _.sortBy(data, [ 'level', 'label', 'display' ])
    }

    sortedData.forEach((o, index) => {
      options.push(
        <option
          key={index}
          value={o.value}
        >
          {o.label}
        </option>
      )
    })
    const defaultValue = placeholder ?? label

    options.unshift(
      <option
        key={-1}
        value='null'
      >
        {defaultValue}
      </option>
    )
    let errorClass = ''

    if (errors && errors.length) {
      errorClass = 'error'
    }

    const labelClass = !value || value === 'null' || placeholder ? 'hidden' : 'select-label'
    return (
      <div
        className='nh-select'
        style={styles}
      >
        {!noFloatingLabel && <label className={labelClass}>{label}</label>}
        <i className='fa fa-caret-down' />
        <select
          style={style(value, errors, disabled, placeholder)}
          className={errorClass}
          placeholder={defaultValue}
          onChange={this.handleChange}
          value={value}
          onBlur={onBlur}
          disabled={disabled}
        >
          {options}
        </select>
        <span className='bar' />
        {this.renderRequired()}
        <ErrorMessage errors={errors} />
      </div>
    )
  }
}

Select.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Array).isRequired,
  noSort: PropTypes.bool,
  noFloatingLabel: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,

  value: PropTypes.any,
  errors: PropTypes.arrayOf(PropTypes.string)
}
